<template>

    <Head>
        <meta name="title" content="Vocabulario de Series de TV y Películas - 5000 Palabras Usadas Frecuentemente" />
        <title>Vocabulario de Series de TV y Películas - 5000 Palabras Usadas Frecuentemente</title>
        <meta name="description"
            content="Para aquellos que desean aprender inglés con series de TV, hemos determinado las 5000 palabras más usadas en las series de TV en inglés." />
    </Head>
    <div class="container pt-5 mt-5 pb-3">

        <div class="row mx-auto">
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="col-12 col-md-8 mx-auto">
                <h1 class="archivo">Vocabulario de Series de TV y Películas - 5000 Palabras Usadas Frecuentemente</h1>

                <p>Aprender las palabras más comúnmente usadas en inglés tiene muchas ventajas. Puede abrir nuevas
                    puertas en tu
                    vida profesional o académica. Una vez que aprendas estas palabras, podrás entender series de TV y
                    películas
                    cómodamente con o sin subtítulos en inglés. Además, dado que la siguiente lista contiene palabras
                    usadas más
                    frecuentemente en el lenguaje cotidiano, aprender estas palabras también mejorará tus habilidades de
                    habla en
                    inglés. Hemos analizado aproximadamente 60 series y 60 películas, identificando las 5000 palabras
                    más comúnmente
                    usadas en inglés. ¡Incluso encontramos los significados de cada una de ellas! Para ir más allá,
                    hemos preparado
                    cuestionarios donde puedes practicar estas palabras :) Ahora, echemos un vistazo a la lista de 5000
                    palabras:
                </p>

                <div v-if="false" class="ad-container-yatay">
                    <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990" data-ad-format="auto"
                        :data-full-width-responsive="true">
                    </Adsense>
                </div>

                <div class="row mt-5">
                    <WordListComponent v-if="isReady" :wordList="wordListData.words" :sliderValueArg="[1, 9]">
                    </WordListComponent>
                    <Loading style="" v-else />
                </div>
                <div v-if="list_index < 5" class="row mt-5 mx-auto">
                    <div class="col-4 mx-auto">
                        <button @click="load_words()" class="medium-purple-button">Más</button>
                    </div>
                </div>
            </div>
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
        </div>
        <SuggestedBlogs></SuggestedBlogs>

    </div>

</template>
<script>
import axios from "axios"
import WordListComponent from "../../../components/Shared/WordListComponent.vue";
import SuggestedBlogs from "../../../components/Shared/SuggestedBlogs.vue";
export default {
    data() {
        return {
            wordListData: {},
            isReady: false,
            list_index: 1,
            list_ids: [943, 945, 946, 947, 948]
        };
    },
    components: {
        WordListComponent,
        SuggestedBlogs
    },
    created() {
        this.$store.commit('setEditOption', false)

        axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: 943, MeanLanguageType: 3 } }).then((response) => {
            this.wordListData = response.data

        }).finally(() => {
            this.isReady = true
        }).catch(error => {
            console.log(error.response.data)
        })
    },
    methods: {
        load_words() {
            if (this.list_index < 5) {
                axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: this.list_ids[this.list_index], MeanLanguageType: 3 } }).then((response) => {
                    let words = response.data.words
                    this.wordListData.words.push(...words)
                }).finally(() => {
                    this.isReady = true
                    this.list_index += 1
                }).catch(error => {
                    console.log(error.response.data)
                })
            }
        }
    },
}

</script>